module.exports = __webpack_public_path__ + "img/menu-thai-express.83273953.webp";